import React from 'react';
import { DisplayMode, RenderForm } from '@atlassian/proforma-common-core/form-system';
import { FormNameWrapper } from './styled';
export const FormWithName = ({
  formStore
}) => /*#__PURE__*/React.createElement("div", {
  "data-testid": "proforma-jira-issue-forms.ui.issue-forms.render-form"
}, /*#__PURE__*/React.createElement(FormNameWrapper, null, formStore.formName), /*#__PURE__*/React.createElement(RenderForm, {
  formStore: formStore,
  displayMode: DisplayMode.Edit
}));